function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { convertToArrayIfNeeded } from "utils/arrays";
import AssetComponent from "/components/core/asset/asset-component";
import ParagraphComponent from "../paragraph/paragraph-component";
import { isContentEmpty } from "/services/paragraph-service";
import { StyledParagraphAndAssetComponent, StyledContent } from "./paragraph-and-asset-columns-component.scss";
class ParagraphAndAssetComponent extends PureComponent {
    renderParagraphs(paragraphs) {
        return /*#__PURE__*/ _jsx(StyledContent, {
            className: "content-body",
            children: paragraphs.map((paragraph, index)=>/*#__PURE__*/ _jsx("div", {
                    dangerouslySetInnerHTML: {
                        __html: paragraph
                    }
                }, index))
        });
    }
    render() {
        let { content, asset, columnWidth, imageWidth } = this.props;
        let { body: contentBody } = content;
        contentBody = convertToArrayIfNeeded(contentBody);
        const withContent = !isContentEmpty(content);
        const withAsset = asset.image || asset.video;
        return /*#__PURE__*/ _jsx(StyledParagraphAndAssetComponent, {
            className: classnames("paragaph-and-asset-columns", {
                "asset-left": asset.side == "left"
            }),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "top-line",
                style: {
                    width: columnWidth
                },
                children: [
                    withContent && /*#__PURE__*/ _jsx("div", {
                        className: "content-column",
                        children: /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, content))
                    }),
                    withAsset && /*#__PURE__*/ _jsx("div", {
                        className: "asset-column",
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                            width: imageWidth
                        }))
                    })
                ]
            })
        });
    }
}
export { ParagraphAndAssetComponent as default };
ParagraphAndAssetComponent.defaultProps = {
    content: {},
    asset: {}
};
